
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { PERMISSION } from '@/permissions';
import TextButton from '@/components/shared/suites/TextButton.vue';
import SelectLocationsModal from '@/components/multi-location/SelectLocationsModal.vue';

@Component<MultiLocationSettings>({
	components: {
		TextButton,
		SelectLocationsModal
	}
})
export default class MultiLocationSettings extends Vue {
	@Action('setLocationIds', { namespace: 'bulkEdit' }) private setSelectedLocationIds!: (locationIds: string[]) => void;
	@Getter('hasPermission', { namespace: 'auth' }) private hasPermission!: (permission: PERMISSION) => boolean;
	@Getter('getRestaurants', { namespace: 'auth' }) private restaurants!: Tenant[] | null;

	private PERMISSION = PERMISSION;
	private modalTarget: 'menu' | 'settings' | null = null;

	private get hasMultipleLocations(): boolean {
		return (this.restaurants?.length ?? 0) > 1;
	}

	/**
	 * Carry the selected locations to the bulk page through the store, which mirrors them to
	 * sessionStorage so the page survives a reload and can pick a running job back up. Deliberately not
	 * the route query: 500 joined ids run ~19 KB, which 414s on a hard reload.
	 *
	 * @param {string[]} locationIds
	 * @return {void}
	 */
	private onLocationsSubmitted(locationIds: string[]): void {
		const path: string = this.modalTarget === 'menu'
			? '/multi-location-settings/menu'
			: '/multi-location-settings/settings';

		this.modalTarget = null;
		this.setSelectedLocationIds(locationIds);
		this.$router.push({ path }).catch(() => {});
	}
}
